// import IOrder from '~/interfaces/IOrder';
// import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
// import { PAYMENT_METHODS } from '~/utils/getEnums';

// export default function getPrintBluetooth(
//   data: IOrder,
//   { print_description, waiter_name }: ISettingsCompany,
// ) {
//   let products_txt = '';
//   let totals_txt = '';
//   let address_txt = '';
//   let waiter_txt = '';

//   if (waiter_name) {
//     waiter_txt += '------------------------';
//     waiter_txt += `ATENDIDO POR: ${waiter_name}`;
//     waiter_txt += '------------------------';
//   }

//   data.products.forEach(item => {
//     const value = getCurrencyFormatted(parseFloat(item.value));
//     const total = getCurrencyFormatted(parseFloat(item.value) * item.quantity);
//     let complements_txt = '';

//     item.complements.forEach(complement => {
//       complements_txt += `${complement.quantity}x ${complement.item.name}\n`;
//     });

//     products_txt += `${item.quantity}x ${item.name}\n`;

//     if (print_description === '1') {
//       products_txt += `${item.description}\n`;
//     }

//     if (item.observations) {
//       products_txt += `Obs: ${item.observations}\n`;
//     }

//     products_txt += complements_txt;
//     products_txt += `${value} - ${total}\n\n`;
//     // products_txt += '\n';
//   });
//   products_txt += '------------------------';

//   totals_txt += 'TOTAIS\n';
//   totals_txt += `PAGAMENTO       ${PAYMENT_METHODS[data.paymentMethod]}\n`;

//   if (data.thing) {
//     const thing_value = getCurrencyFormatted(
//       parseFloat(data.thing) - data.total,
//     );
//     totals_txt += `TROCO      ${thing_value.padStart(13, ' ')}\n`;
//   }

//   totals_txt += `SUB-TOTAL  ${
//     data.subtotal_formatted ? data.subtotal_formatted.padStart(13, ' ') : ''
//   }\n`;
//   totals_txt += `ENTREGA    ${
//     data.shippingCost_formatted
//       ? data.shippingCost_formatted?.padStart(13, ' ')
//       : ''
//   }\n`;
//   totals_txt += `TOTAL      ${
//     data.total_formatted ? data.total_formatted?.padStart(13, ' ') : ''
//   }`;

//   if (data.address && data.address.road) {
//     address_txt += `------------------------\n`;
//     address_txt += `ENTREGA\n`;
//     address_txt += `RUA: ${data.address.road}\n`;
//     address_txt += `NÚMERO: ${data.address.number}\n`;
//     address_txt += `BAIRRO: ${data.address.neighbourhood}\n`;
//     address_txt += `CIDADE: ${data.address.city} - ${data.address.state}\n`;

//     if (data.address.complement) {
//       address_txt += `COMPLEMENTO: ${data.address.complement}\n`;
//     }

//     if (data.address.reference) {
//       address_txt += `REFERÊNCIA: ${data.address.reference}\n`;
//     }
//   }

//   return `

// ${data.company_name.toLocaleUpperCase()}
// ------------------------
// ${data.created_at_formatted}
// ------------------------
// ${data.name}
// ${data.whatsapp}
// ------------------------
//    CUPOM NÃO FISCAL
// ------------------------
// ${products_txt}
// ${totals_txt}
// ${address_txt}
// ${waiter_txt}
// ------------------------
// PEDIDO: ${data.code}
// ------------------------
//       Tecnologia
// www.tem-pedido.web.app`;
// }

import { isEmpty } from 'lodash';
import IOrder from '~/interfaces/IOrder';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
import { PAYMENT_METHODS } from '~/utils/getEnums';
import getAddressFormatted from './getAddressFormatted';

interface ISettingsCompany {
  print_description: string;
  waiter_name?: string;
  print_payment_value?: boolean;
}

export default function getPrintBluetooth(
  data: IOrder,
  { print_description, waiter_name, print_payment_value }: ISettingsCompany,
) {
  let products_txt = '';
  let totals_txt = '';
  let payment_txt = '';
  let address_txt = '';
  let header_txt = '';
  let waiter_txt = '';

  if (waiter_name) {
    waiter_txt += `ATENDIDO POR: ${waiter_name}`;
  }

  if (data.table?.uid) {
    header_txt = `MESA ${data.table?.name}`;
  } else {
    header_txt = `   ${data.name}\n   ${data.whatsapp}`;
  }

  data.products.forEach(item => {
    const value = getCurrencyFormatted(parseFloat(item.value));
    const total = getCurrencyFormatted(parseFloat(item.value) * item.quantity);
    let complements_txt = '';

    item.complements.forEach(complement => {
      complements_txt += `${complement.quantity}x ${complement.item.name}\n`;
    });

    products_txt += `${item.quantity}x ${item.name}\n`;

    if (print_description === '1' && !!item.description) {
      products_txt += `${item.description}\n`;
    }

    if (item.observations) {
      products_txt += `Obs: ${item.observations}\n`;
    }

    products_txt += complements_txt;
    products_txt += `${value} - ${total}\n\n`;
    // products_txt += '\n';
  });
  products_txt += '------------------------';

  totals_txt += 'TOTAIS\n';

  if (data.paymentMethod) {
    payment_txt += `PAGAMENTO       ${PAYMENT_METHODS[data.paymentMethod]}\n`;
  }

  if (data.orderPayments && data.orderPayments.length > 0) {
    payment_txt += 'PAGAMENTO\n';
    data.orderPayments.forEach(item => {
      payment_txt += `${
        PAYMENT_METHODS[item.payment_method_id]
      }                 ${item.value_formatted}\n`;
    });
  }

  if (print_payment_value && data.thing) {
    const received = getCurrencyFormatted(parseFloat(data.thing));
    totals_txt += `RECEBER             ${received.padStart(13, ' ')}\n`;
  }

  if (data.thing) {
    const thing_value = getCurrencyFormatted(
      parseFloat(data.thing) - data.total,
    );
    totals_txt += `TROCO      ${thing_value.padStart(13, ' ')}\n`;
  }

  if (
    data.additionValue &&
    data.additionValue > 0 &&
    data.additionValue_formatted
  ) {
    totals_txt += `ACRÉSCIMO      ${data.additionValue_formatted.padStart(
      13,
      ' ',
    )}\n`;
  }

  totals_txt += `SUB-TOTAL  ${
    data.subtotal_formatted ? data.subtotal_formatted.padStart(13, ' ') : ''
  }\n`;
  totals_txt += `ENTREGA    ${
    data.shippingCost_formatted
      ? data.shippingCost_formatted?.padStart(13, ' ')
      : ''
  }\n`;

  totals_txt += `TOTAL      ${
    data.total_formatted ? data.total_formatted?.padStart(13, ' ') : ''
  }`;

  if (data.artisticCouvertTotal && data.artisticCouvertTotal > 0) {
    totals_txt += `COUVERT  ${
      data.artisticCouvertTotal
        ? getCurrencyFormatted(data.artisticCouvertTotal)
        : ''
    }\n`;
  }

  if (!isEmpty(data.address) && data.address.road) {
    address_txt += `------------------------\n`;
    address_txt += `ENTREGA\n`;
    address_txt += `${getAddressFormatted(data.address)}`;
  }

  if (!isEmpty(data.address) && !data.address.road) {
    address_txt += `------------------------\n`;
    address_txt += `ENTREGA\n`;
    address_txt += `${data.address}`;
  }

  if (isEmpty(data.address)) {
    address_txt += `------------------------\n`;
    address_txt += `ENTREGA\n`;
    address_txt += `RETIRADA LOCAL`;
  }

  return `
${data.company_name.toLocaleUpperCase()}
------------------------
${data.created_at_formatted}
------------------------
${header_txt}
------------------------
    CUPOM NÃO FISCAL
------------------------
${products_txt}
${totals_txt}
------------------------
${payment_txt}${address_txt}${waiter_txt}
------------------------
PEDIDO: ${data.code}
------------------------
       Tecnologia
 www.tem-pedido.web.app`;
}
